module.exports = __webpack_public_path__ + "static/media/pages.7db7f508.svg";